// "Studying now": the rounded count of browsers in a focus session, from the presence reply.
// The server leaves it out below 10 and rounds it to 5, so this only words it. Plain functions,
// no DOM, so the start page, the Island panel and the tests share one wording.
export const STUDYING_MIN = 10;

export function studyingShown(n, enabled) {
	return enabled !== false && Number.isInteger(n) && n >= STUDYING_MIN;
}

export function studyingText(n, enabled) {
	return studyingShown(n, enabled) ? "About " + n.toLocaleString("en-US") + " people are studying right now" : "";
}

// Fills (or hides) one line element. Returns whether it shows.
export function paintStudying(el, n, enabled) {
	if (!el) return false;
	const text = studyingText(n, enabled);
	if (el.textContent !== text) el.textContent = text;
	el.hidden = !text;
	return !!text;
}
